import { render, staticRenderFns } from "./PreviousTransactions.vue?vue&type=template&id=5976d0ff&scoped=true&"
import script from "./PreviousTransactions.vue?vue&type=script&lang=js&"
export * from "./PreviousTransactions.vue?vue&type=script&lang=js&"
import style0 from "./PreviousTransactions.vue?vue&type=style&index=0&id=5976d0ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5976d0ff",
  null
  
)

export default component.exports